import React, { Component } from 'react'
import { Col, Container, Row, Image } from 'react-bootstrap';
import { ArrowRight, Globe, GitHub } from 'react-feather';
import Navbar from '../components/Navbar'
import '../styles/Portfolio.css';

export default class Portfolio extends Component {
    render() {
        return (
            <div className='portfolio-css'>


                <header className='dark-bg'>
                    <Navbar />

                    <Container className='main-container' fluid>
                        <Row>

                            <Col md='12' className='main-project-view'>
                                <Row className='project-desc-view'>

                                    <Col md='6'>
                                        <div className='project-images'>
                                            <div className='iphone '>
                                                <span className='binder mx-auto my-auto'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044189/raven2_f8kl7p.png' alt="Raven image 1" className='image mx-auto my-auto' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-2'>
                                                <span className='binder '>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631046354/Screenshot_20210313-143702_2_htlay7.png' alt="Raven image 2" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-3 '>
                                                <span className='binder'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044179/raven3_grxg6n.png' alt="Raven image 3" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col md='6' >
                                        <div className='project-desc'>
                                            <div className='project-num'>
                                                <h1>
                                                    1
                                                </h1>
                                            </div>
                                            <h2>
                                                Raven Livestream<span className='sub-head-dot'>.</span>
                                            </h2>
                                            <p style={{ marginBottom: 0 }}>
                                                Raven is a video live-streaiming app that helps millions of creators host and monetize live and virtual events worldwide.
                                            </p>

                                            <a href='https://play.google.com/store/apps/details?id=com.ravenlivestream.raven&hl=en_US&gl=US' target="_blank" rel="noreferrer">
                                                <div className='project-view'>
                                                    <Globe size='20' className='globe' />
                                                    <p>View live product</p>
                                                    <div class="project-icon ">
                                                        <ArrowRight size='17' />
                                                    </div>
                                                </div>
                                            </a>



                                        </div>
                                    </Col>
                                </Row>

                            </Col>

                            <Col md='12' className='main-project-view'>
                                <Row className='project-desc-view'>

                                    <Col md='6'>
                                        <div className='project-images'>
                                            <div className='iphone '>
                                                <span className='binder mx-auto my-auto'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044149/fixme1_gfuysy.png' alt="Fixme image 1" className='image mx-auto my-auto' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-2'>
                                                <span className='binder '>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044154/fixme3_doxgif.png' alt="Fixme image 2" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-3 '>
                                                <span className='binder'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044151/fixme2_upk9nv.png' alt="Fixme image 3" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col md='6' >
                                        <div className='project-desc'>
                                            <div className='project-num'>
                                                <h1>
                                                    2
                                                </h1>
                                            </div>
                                            <h2>
                                                Fixme<span className='sub-head-dot'>.</span>
                                            </h2>
                                            <p style={{ marginBottom: 0 }}>
                                                Fixme is a mobile app that helps connect users to nearby service providers, and enables them to make secure transactions with businesses.
                                            </p>

                                            <a href='https://play.google.com/store/apps/details?id=com.fixme&hl=en_US&gl=US' target="_blank" rel="noreferrer">
                                                <div className='project-view'>
                                                    <Globe size='20' className='globe' />
                                                    <p>View live product</p>
                                                    <div class="project-icon ">
                                                        <ArrowRight size='17' />
                                                    </div>
                                                </div>
                                            </a>

                                        </div>
                                    </Col>
                                </Row>

                            </Col>

                            <Col md='12' className='main-project-view'>
                                <Row className='project-desc-view'>

                                    <Col md='6'>
                                        <div className='project-images'>
                                            <div className='iphone '>
                                                <span className='binder mx-auto my-auto'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044205/deaddiction2_wv5lmz.png' alt="deaddiction image 1" className='image mx-auto my-auto' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-2'>
                                                <span className='binder '>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044201/deaddiction1_qgetg1.png' alt="deaddiction image 2" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-3 '>
                                                <span className='binder'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044206/deaddiction3_pm2gti.png' alt="deaddiction image 3" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col md='6' >
                                        <div className='project-desc'>
                                            <div className='project-num'>
                                                <h1>
                                                    3
                                                </h1>
                                            </div>
                                            <h2>
                                                Deaddiction app<span className='sub-head-dot'>.</span>
                                            </h2>
                                            <p style={{ marginBottom: 0 }}>
                                                A mobile application to deaddict users from their cell phones and reduce mobile usage using gamification as a strategy.
                                            </p>

                                            <a href='https://github.com/EmmanuelJoshua/app_usage_tracker' target="_blank" rel="noreferrer">
                                                <div className='project-view'>
                                                    <GitHub size='20' className='globe' />
                                                    <p>View source code</p>
                                                    <div class="project-icon ">
                                                        <ArrowRight size='17' />
                                                    </div>
                                                </div>
                                            </a>



                                        </div>
                                    </Col>
                                </Row>

                            </Col>

                            <Col md='12' className='main-project-view'>
                                <Row className='project-desc-view'>

                                    <Col md='6'>
                                        <div className='project-images'>
                                            <div className='iphone '>
                                                <span className='binder mx-auto my-auto'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044197/calculator1_yjpd5j.png' alt="Calculator image 1" className='image mx-auto my-auto' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-2'>
                                                <span className='binder '>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044197/calculator2_leikvq.png' alt="Calculator image 2" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-3 '>
                                                <span className='binder'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044202/calculator3_cty7jv.png' alt="Calculator image 3" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col md='6' >
                                        <div className='project-desc'>
                                            <div className='project-num'>
                                                <h1>
                                                    4
                                                </h1>
                                            </div>
                                            <h2>
                                                Calculator app<span className='sub-head-dot'>.</span>
                                            </h2>
                                            <p style={{ marginBottom: 0 }}>
                                                A multi-purpose utility mobile application with a currency converter, a basic calculator, tip calculator and
                                                QR code scanner.
                                            </p>

                                            <a href='https://github.com/EmmanuelJoshua/CalculatorApp' target="_blank" rel="noreferrer">
                                                <div className='project-view'>
                                                    <GitHub size='20' className='globe' />
                                                    <p>View source code</p>
                                                    <div class="project-icon ">
                                                        <ArrowRight size='17' />
                                                    </div>
                                                </div>
                                            </a>



                                        </div>
                                    </Col>
                                </Row>

                            </Col>

                            <Col md='12' className='main-project-view'>
                                <Row className='project-desc-view'>

                                    <Col md='6'>
                                        <div className='project-images'>
                                            <div className='iphone '>
                                                <span className='binder mx-auto my-auto'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044204/creditcard2_e55w2c.png' alt="Creditcard image 1" className='image mx-auto my-auto' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-2'>
                                                <span className='binder '>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044202/creditcard1_nk1zm4.png' alt="Creditcard image 2" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                            <div className='iphone-3 '>
                                                <span className='binder'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044200/creditcard3_f2cto3.png' alt="Creditcard image 3" className='image' width="267" height="579" />
                                                </span>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col md='6' >
                                        <div className='project-desc'>
                                            <div className='project-num'>
                                                <h1>
                                                    5
                                                </h1>
                                            </div>
                                            <h2>
                                                Credit card tracker<span className='sub-head-dot'>.</span>
                                            </h2>
                                            <p style={{ marginBottom: 0 }}>
                                                A mobile application to keep track of your credit cards informations, transactions and spending info. Built with Firebase
                                            </p>

                                            <a href='https://github.com/EmmanuelJoshua/creditcardapp' target="_blank" rel="noreferrer">
                                                <div className='project-view'>
                                                    <GitHub size='20' className='globe' />
                                                    <p>View source code</p>
                                                    <div class="project-icon ">
                                                        <ArrowRight size='17' />
                                                    </div>

                                                </div>
                                            </a>



                                        </div>
                                    </Col>
                                </Row>

                            </Col>

                        </Row>
                    </Container>
                </header>
            </div >
        )
    }
}